import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import moment from "moment";

export default function SegmentDetail(props) {
    const findDuration = (d1) => {
        if (d1)
            return d1.replace('P', '').replace('D', 'd ').replace('T', '').replace('H', 'h ').replace('M', 'm')
    }

    const getDateDifference = (d1, d2) => {
        //d1 > d2
        let a = moment(d1);
        let b = moment(d2);

        let min = a.diff(b, 'minutes')
        let hr = a.diff(b, 'hours')
        return hr + "h " + (min - hr * 60) + "m"
    }

    const { segment, index, segments } = props;
    return (
    <>
        {index > 0 && <Typography style={{
            color: 'black',
            background: '#E2E2E8',
            padding: '6px',
            fontSize: '12px',
            fontWeight: '400',
            borderRadius: '4px',
            marginRight: "15px",
            marginBottom: "15px",
        }} component="span">{`${getDateDifference(segment.departing_at, segments[index - 1].arriving_at)} Layover at ${segment.origin?.name + ' (' + segment.origin?.iata_code + ')'}`}{segment.vi_connection && <><br></br>You must collect and recheck your baggage<br></br>{`Self transfer at ${segment.cityFrom + ' (' + segment.flyFrom + ')'}`}</>}</Typography>}
        <Grid item xs="12">
            <Grid container>
                <Grid item xs="2" sm="1">
                    <div class="jsx-42120747 circle" style={{
                        boxSizing: 'content-box',
                        position: 'relative',
                        top: '10px',
                        flexShrink: '0',
                        width: '12px',
                        height: '12px',
                        borderRadius: '12px',
                        marginLeft: '16px',
                        marginRight: '32px',
                        border: '2px solid #ABABB4'
                    }}></div>
                </Grid>
                <Grid item xs="10" sm="11">
                    <Typography component="span" style={{ fontWeight: "bold", fontSize: '15px' }}>{moment(segment.departing_at).format('llll')}</Typography><Typography component="span" style={{ fontSize: '15px' }}>{'   Depart at ' + segment.origin?.name + '(' + segment.origin?.iata_code + ')'}</Typography>
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs="12">
            <Grid container >
                <Grid item xs="2" sm="1">
                    <div style={{
                        content: "",
                        width: '4px',
                        height: '100%',
                        backgroundImage: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAADwCAMAAAD8WVBVAAAAb1BMVEUAAAC/v8+/v9+/v9e/w9u/wtm/wty/xdrBxt2/xNi/xNvBxdu/w9m/w9vBxNu/w9q/w9zAxNzAxdy/wtm/wtrAw9zAxdvAxdy/xNnAxNvAxNrAxNvAxN3AxNrAxNzAxdzAw9vAw9zAxNvAxNzAxNtGKypvAAAAJHRSTlMAEBAgQFBQYG9wcH+AgI+QkJ+foKCvr6+wv8/Pz9/f3+/v7+9leMSZAAABiklEQVR4Ae3bW5LTMBBG4XakJIwxYRIuIITMhX//ayS8ApWJLp6uqTrfBk61rDe3DAAAAAAAAAAAAAC2Mu3nSy66KunjEqdnqr5O+kuag20tJv1Xii7ZP9a9bSUk3XQOtolXP/SE9WjjTSfd4TS+m3WXHGyosOpOa/DpSutk42RVyOPKJ1U52SBHVXoY+oEr/Aw2wlnVkg1wUINo/VbJZeQo+YycJJeRgxpN1mdWo8XnpLvPeif5nHVUs731WNTswXp8ULOLz92SvliPombfrIc6vPgwYcKECRMmTJgwYcKECRMmTJgwYcKECRMmTJgwYcKECRP2/3H9Vc2S9XinZp/7N248dm4Oahb9V24cl4waLB0bNz5nHfxX5xyWBR1GLtYvNm+ROYx8thHCL1UqwYaYVelogzyqylsbZZdVIds4u9L/gduE4tK9Crn/yUCjx/571ehY9ITvs20ivNdNKdhWDuVGNno9LdtamNM/1TfP9ZAvLp9S0VXJl/mwWRUAAAAAAAAAAAAAfgPrRYYX/D3mLQAAAABJRU5ErkJggg==)',
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'repeat-y',
                        backgroundSize: 'contain',
                        marginLeft: '22px',
                        marginTop: "3px"
                    }}></div>
                </Grid>
                <Grid item xs="10" sm="11" style={{ paddingTop: "20px", paddingBottom: "20px" }}>
                    <Typography component="span" style={{ fontSize: '12px' }}>{'Flight duration: ' + findDuration(segment.duration)}</Typography>
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs="12">
            <Grid container>
                <Grid item xs="2" sm="1">
                    <div class="jsx-42120747 circle" style={{
                        boxSizing: 'content-box',
                        position: 'relative',
                        top: '9px',
                        flexShrink: '0',
                        width: '12px',
                        height: '12px',
                        borderRadius: '12px',
                        marginLeft: '16px',
                        marginRight: '32px',
                        border: '2px solid #ABABB4'
                    }}></div>
                </Grid>
                <Grid item xs="10" sm="11">
                    <Typography component="span" style={{ fontWeight: "bold", fontSize: '15px' }}>{moment(segment.arriving_at).format('llll')}</Typography><Typography component="span" style={{ fontSize: '15px' }}>{'   Arrive at ' + segment.destination?.name + '(' + segment.destination?.iata_code + ')'}</Typography>
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs="12" style={{ marginBottom: '25px' }}>
            <Grid container>
                <Grid item xs="2" sm="1">
                </Grid>
                <Grid item xs="10" sm="11">
                    <Typography component="span" style={{ fontSize: '12px' }}>{segment.passengers ? segment.passengers[0].cabin_class_marketing_name : ''}</Typography>&nbsp;&nbsp;&nbsp;
                    <Typography component="span" style={{ fontSize: '12px' }}>{'Operated By ' + segment.operating_carrier?.name}</Typography>&nbsp;&nbsp;&nbsp;
                    <Typography component="span" style={{ fontSize: '12px' }}>{segment.aircraft?.name}</Typography>
                </Grid>
            </Grid>
        </Grid>
    </>)
}